import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Icon, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center'
  },
  title: {
    padding: theme.spacing(3)
  },
  heading: {
    margin: 0
  },
  content: {
    padding: theme.spacing(0, 3)
  },
  actions: {
    padding: theme.spacing(3)
  }
}));

interface ConfirmDialogInterface {
  open: boolean,
  setOpen: (value: boolean) => void,
  deleteMethod: () => void
}
export default function Confirm ({ open, setOpen, deleteMethod }: ConfirmDialogInterface) {
  const classes = useStyles();
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    return () => {
      setBusy(false);
      setOpen(false);
    };
  }, [setOpen]);
  const handleClose = async (event: object, reason?: string) => {
    if (busy && (reason === 'escapeKeyDown' || reason === 'backdropClick')) {
      return;
    }
    setOpen(false);
  };
  const handleConfirm = async () => {
    setBusy(true);
    await deleteMethod();
  };
  return (
    <Dialog
      maxWidth='md'
      open={open}
      onClose={handleClose}
      aria-labelledby='logout-session-dialog-title'
      aria-describedby='logout-session-dialog-description'
      className={classes.root}
    >
      <DialogTitle
        disableTypography
        className={classes.title}
      >
        <Translate
          content='account_security_logout_dialog_title'
          component='h3'
          className={classes.heading}
        />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Translate
          content='account_security_logout_dialog_description'
        />
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button disabled={busy} onClick={handleClose} color='primary'>
          <Translate content='cancel' />
        </Button>
        <Button disabled={busy} onClick={handleConfirm} variant='contained' color='primary' autoFocus>
          {
            busy ? <><Icon size='sm' type='loader' color='white' />&nbsp;</> : <Translate content='confirm' />
          }
        </Button>
      </DialogActions>
    </Dialog>
  );
}
